import type { StatusIntents } from '~/theme/variants';

export function getDisciplineIntent(disciplineId: number): StatusIntents {
	switch (disciplineId) {
		case 1:
			return 'skilledNursing';
		case 2:
			return 'physicalTherapy';
		case 3:
			return 'occupationalTherapy';
		case 4:
			return 'speechTherapy';
		case 5:
			return 'medicalSocialWork';
		case 6:
			return 'homeHealthAide';
		default:
			return 'neutral';
	}
}
